// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"styles_formGroup__3Jhdb","btnFormGroup":"styles_btnFormGroup__KlA8J"};